import { CircularProgress } from '@mui/material';
import { Theme, alpha, ClassNameMap } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { ReactElement } from 'react';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pmiOverlay: () => ({
      backgroundColor: alpha(theme.palette.grey[500], 0.3),
      zIndex: 3000,
    }),
  })
);

interface OverlaySpinnerProps {
  visible: boolean;
  ariaLabel?: string;
}

const OverlaySpinner = ({
  visible,
  ariaLabel = 'Caricamento in corso',
}: OverlaySpinnerProps): ReactElement | null => {
  const classes = useStyles() as ClassNameMap<string>;

  if (!visible) {
    return null;
  }

  return (
    <div className={classNames('pmi-position-fixed pmi-w-100 pmi-h-100', classes.pmiOverlay)}>
      <div className="pmi-fixed-center">
        <CircularProgress aria-busy="true" aria-label={ariaLabel} />
      </div>
    </div>
  );
};

OverlaySpinner.displayName = 'OverlaySpinner';

export default OverlaySpinner;
